import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CircuitStockStatusState } from "../objects/circuitStockStatusState";
import { CircuitCalendar, CircuitFromBackend } from "../objects/calendarCircuit";
import { EMPTY_CALENDAR_CRITERIA } from "../constant/circuitStockStatusConstant";

const initialState: CircuitStockStatusState = {
    circuits: [],
    calendar: { calendar_blocks: [], allowed_dates: {} },
    extremum_date: { min_date: null, max_date: null },
    calendar_criteria: EMPTY_CALENDAR_CRITERIA,
    refresh: false,
    update_stock: null,
    update_stock_confirmation: null,
    is_editing_stock: false,
};

const updateCircuitsReducer = (state: CircuitStockStatusState, action: PayloadAction<CircuitFromBackend[]>): CircuitStockStatusState => ({
    ...state,
    circuits: action.payload
});

const updateCalendarReducer = (state: CircuitStockStatusState, action: PayloadAction<CircuitCalendar>): CircuitStockStatusState => ({
    ...state,
    calendar: action.payload
});

const updateExtremumDateReducer = (state: CircuitStockStatusState, action: PayloadAction<CircuitStockStatusState['extremum_date']>): CircuitStockStatusState => ({
    ...state,
    extremum_date: action.payload
});

const setCalendarCriteriaReducer = (state: CircuitStockStatusState, action: PayloadAction<CircuitStockStatusState['calendar_criteria']>): CircuitStockStatusState => ({
    ...state,
    calendar_criteria: action.payload
});
const setRefreshReducer = (state: CircuitStockStatusState): CircuitStockStatusState => ({
    ...state,
    refresh: !state.refresh
});


const setUpdateStockReducer = (state: CircuitStockStatusState, action: PayloadAction<{ date: string; block: CircuitCalendar['calendar_blocks'][number]; } | null>): CircuitStockStatusState => ({
    ...state, update_stock: action.payload
});
const setUpdateStockConfirmationReducer = (state: CircuitStockStatusState, action: PayloadAction<{ date: string; block: CircuitCalendar['calendar_blocks'][number]; } | null>): CircuitStockStatusState => ({
    ...state, update_stock_confirmation: action.payload
});

const setIsEditingStockReducer = (state: CircuitStockStatusState, action: PayloadAction<boolean>): CircuitStockStatusState => ({
    ...state,
    is_editing_stock: action.payload
});

const updateCircuitBlackoutsReducer = (state: CircuitStockStatusState, action: PayloadAction<{ circuitId: number; blackouts: any[] }>): CircuitStockStatusState => ({
    ...state,
    circuits: state.circuits.map(circuit =>
        circuit.id === action.payload.circuitId
            ? { ...circuit, black_out: action.payload.blackouts }
            : circuit
    )
});

export const circuitStockStatusSlice = createSlice({
    name: 'circuit_stock_status',
    initialState,
    reducers: {
        updateCircuits: updateCircuitsReducer,
        updateCalendar: updateCalendarReducer,
        updateExtremumDate: updateExtremumDateReducer,
        setCalendarCriteria: setCalendarCriteriaReducer,
        setRefresh: setRefreshReducer,
        setUpdateStock: setUpdateStockReducer,
        setUpdateStockConfirmation: setUpdateStockConfirmationReducer,
        setIsEditingStock: setIsEditingStockReducer,
        updateCircuitBlackouts: updateCircuitBlackoutsReducer
    }
});

export const {
    updateCircuits,
    updateCalendar,
    updateExtremumDate,
    setCalendarCriteria,
    setRefresh,
    setUpdateStock,
    setUpdateStockConfirmation,
    setIsEditingStock,
    updateCircuitBlackouts
} = circuitStockStatusSlice.actions;